import React, { Component } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { getCmsContent_action } from '../actions/cms_action/cmsAction';
import { connect } from "react-redux";
import $ from 'jquery';
import { withRouter } from '../utils/withRouter';
import purify from 'dompurify'
import { toastError } from '../utils/constants';

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      footerData: []
    };
    this.loadscript()
  }
  componentDidMount() {
    if (Array.isArray(this.props.footerData) && this.props.footerData.length > 0) {
      this.setState({ footerData: this.props.footerData })
    } else {
      console.log('else header')
      this.getCmsContent(1, 'home');
    }
  }
  loadscript() {
    $(document).ready(function () {
      $(this).scrollTop(0);
    });
  }

  getCmsContent = async (MenuID, MenuUrl) => {
    const formattedMenuUrl = MenuUrl?.startsWith('/') ? MenuUrl.substring(1) : MenuUrl;
    try {
      this.setState({ isLoading: true });

      const data = await this.props.getCmsContent_action(MenuID ? MenuID : 1, formattedMenuUrl ? formattedMenuUrl : 'home');
      if (data.error !== 1) {
        this.setState({
          isLoading: false,
          footerData: data?.data[2][0] !== "" ? data?.data[2][0] : [],
        });
      } else {
        this.setState({ isLoading: false });
        toastError(data.msg);
      }
    } catch (err) {
      console.error(err);
      this.setState({ isLoading: false });
    }
  }
  
  onClickLoginSignUp() {
    localStorage.removeItem("award_event_profile_id")
    this.props.navigate('/signUp')
  }

  render() {
    const { } = this.state;
    const { footerData } = this.props
    return (
      <>
        {(footerData && footerData.isActive) && (
          < div
            dangerouslySetInnerHTML={{
              __html: purify.sanitize(footerData?.FooterContent),
            }}
          />
        )}

        {/* <footer class="footer-section pt-100 bg-theme-color2">
          <div class="widget-area style1  pb-40">
            <div class="container">
              <div class="footer-layout style1">
                <div class="row">
                  <div class="col-xl-3 col-md-6 col-12">
                    <div class="widget footer-widget wow fadeInUp" data-wow-delay=".6s">
                      <div class="gt-widget-about">
                        <div class="about-logo">
                          <a href="index.html"><img src="assets/img/footer_logo.png" alt="extech" /></a>
                        </div>
                        <p class="about-text"> India ITME Society is only on the verge of bringing more and more for the betterment of the textile ecosystem and overall growth of the textile industry
                        </p>
                        <div class="gt-social style2">
                          <a target='blank' href="https://www.facebook.com/indiaitmesociety"><i class="fa fa-facebook-f"></i></a>
                          <a target='blank' href="https://www.linkedin.com/company/india-itme"><i class="fa fa-linkedin"></i></a>
                          <a target='blank' href="https://www.youtube.com/c/IndiaITMESociety"><i class="fa fa-youtube-play"></i></a>
                          <a target='blank' href="https://www.instagram.com/indiaitme"><i class="fa fa-instagram"></i></a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-2 col-md-6 col-12">
                    <div class="widget widget_nav_menu footer-widget wow fadeInUp" data-wow-delay="1s">
                      <h3 class="widget_title responsive-top-space">About</h3>
                      <div class="menu-all-pages-container">
                        <ul class="menu">
                          <li><a onClick={() => navigate('/indiaItmeSociety')}>India ITME Society</a></li>
                          <li><a onClick={() => navigate('/itmeTradeServices')}>ITMES Trade Services</a></li>
                          <li><a onClick={() => navigate('/whyIndia')}>Why India</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-2 col-md-6 col-12">
                    <div class="widget widget_nav_menu footer-widget wow fadeInUp" data-wow-delay="1s">
                      <h3 class="widget_title">Services</h3>
                      <div class="menu-all-pages-container">
                        <ul class="menu">
                          <li><a onClick={() => navigate('/tradeMission')}>Trade Missions</a></li>
                          <li onClick={() => navigate('/knowledgeSessions')}><a >Knowledge sessions</a></li>
                          <li onClick={() => navigate('/internationalExhibitions')}> <a >International Exhibitions</a></li>
                          <li><a onClick={() => navigate('/tradeEnquiry')}>Trade enquiry</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-2 col-md-6 col-12">
                    <div class="widget widget_nav_menu footer-widget wow fadeInUp" data-wow-delay="1s">
                      <h3 class="widget_title">News & PR</h3>
                      <div class="menu-all-pages-container">
                        <ul class="menu">
                          <li><a onClick={() => navigate('/photoGallery')}>Photo Gallery</a></li>
                          <li><a onClick={() => navigate('/videoGallery')}>Video Gallery</a></li>
                          <li><a onClick={() => navigate('/mediaCoverage')}>Media Coverage</a></li>
                          <li><a onClick={() => navigate('/pressRelease')}>Press Release</a></li>
                          <li><a onClick={() => navigate('/mediaKit')}>Media Kit</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-3 col-md-6 col-12">
                    <div class="widget widget_nav_menu footer-widget wow fadeInUp" data-wow-delay="1.6s">
                      <h3 class="widget_title">Contact Us</h3>
                      <div class="checklist style2">
                        <ul class="ps-0">
                          <li class="text-white"><i class="fa fa-solid fa-map"></i></li>
                          <li class="text-white"><span style={{ fontWeight: 600 }}>India ITME Society</span>, <br />1210/1211/1212 Dalamal Tower, ‘A’ Wing, 12th Floor, Plot No.211, Nariman Point, Mumbai – 400 021, INDIA</li>
                        </ul>
                        <ul class="ps-0">
                          <li class="text-white"><i class=" fa fa-solid fa-envelope"></i></li>
                          <li class="text-white">itme@india-itme.com</li>
                        </ul>
                        <ul class="ps-0">
                          <li class="text-white"><i class="fa fa-solid fa-phone"></i></li>
                          <li class="text-white">+91-22-4972 4603</li>
                        </ul>


                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="copyright-wrap bg-theme">
            <div class="container">
              <div class="copyright-layout">
                <div class="layout-text wow fadeInUp" data-wow-delay=".3s">
                  <p class="copyright" style={{ cursor: 'default' }}>
                    <i class="fa fa-copyright" style={{ cursor: 'default' }}></i> All Copyright 2024 by India ITME Society
                  </p>
                </div>
                <div class="layout-link wow fadeInUp" data-wow-delay=".6s">
                  <div class="link-wrapper">
                    <a onClick={() => navigate('/termsAndCondition')}>Terms &amp; Condition </a>
                    <a onClick={() => navigate('/privacyPolicy')}>Privacy Policy</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer> */}

      </>
    );
  }
}
export default withRouter(
  connect(null, { getCmsContent_action })(Footer)
);
